import { render, staticRenderFns } from "./PaymentDistributionAddFundsModal.vue?vue&type=template&id=41be32c4"
import script from "./PaymentDistributionAddFundsModal.vue?vue&type=script&lang=js"
export * from "./PaymentDistributionAddFundsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports